import I18N from '@leverege/i18n';
const {
  t,
  tIcon
} = I18N.ns('molten.screens.group.ClearSearchAction');
export default {
  id: 'molten.screens.group.search.ClearSearchAction',
  matches: {
    use: 'actionBar',
    client: ['molten.group.SearchBar', 'molten.groupMobile.SearchBar']
  },
  layout: {
    sort: 'aaaa'
  },
  handles: ({
    value
  }) => {
    return !!value;
  },
  appearance: ({
    context
  }) => {
    return {
      name: t('name'),
      icon: tIcon('icon', 'fa fa-fw fa-times')
    };
  },
  perform: ({
    context: {
      clearSearch
    }
  }) => {
    clearSearch();
  }
};